module.exports = __webpack_public_path__ + "static/CooperHewitt-Medium-da25a0c11cae8400d9bbb4561e3bb5a2.otf";